import { baseAtomMappingClient, baseOrganismMappingClient } from '@/client/options/definition/option-mappings.client';
import optionTypes from '@/options/definition/option-types';

// the toolbar will sort the option GROUPS in the order they are listed here
// to update the sorting of each individual options see option-types.js

export const baseAtomMapping = {
    layout: [
        optionTypes.layout.offset,
        optionTypes.layout.alignSelf,
        optionTypes.layout.boxed,
        optionTypes.layout.placement,
        optionTypes.layout.zIndex,
        ...baseAtomMappingClient.layout,
    ],

    component: [
        optionTypes.component.addPreset,
        optionTypes.component.hoverTransition,
        optionTypes.component.border,
        optionTypes.component.margin,
        optionTypes.component.padding,
        optionTypes.component.cursor,
        optionTypes.component.skewY,

        ...baseAtomMappingClient.component,
    ],

    html: [
        optionTypes.html.dataDynamic,
        optionTypes.html.flexEvents,
        optionTypes.html.htmlCustomAttributes,
        optionTypes.html.isLink,
    ],

    linkBuilder: [optionTypes.linkBuilder.linkBuilder],
    text: [...baseAtomMappingClient.text],

    visibility: [
        optionTypes.visibility.disabled,
        optionTypes.visibility.opacity,
        optionTypes.visibility.visibility,

        ...baseAtomMappingClient.visibility,
    ],

    accessibility: [
        optionTypes.accessibility.ariaLabel,
        optionTypes.accessibility.ariaLabelledBy,
        optionTypes.accessibility.accessibilityRole,
        optionTypes.accessibility.ariaHidden,

        ...baseOrganismMappingClient.accessibility,
    ],
};


export const baseOrganismMapping = {
    layout: [
        optionTypes.layout.offset,
        optionTypes.layout.alignSelf,
        optionTypes.layout.boxed,
        optionTypes.layout.height,
        optionTypes.layout.maxHeight,
        optionTypes.layout.maxWidth,
        optionTypes.layout.minHeight,
        optionTypes.layout.minWidth,
        optionTypes.layout.overflow,
        optionTypes.layout.sticky,
        optionTypes.layout.width,
        optionTypes.layout.zIndex,
        ...baseOrganismMappingClient.layout,
    ],

    component: [
        optionTypes.component.hoverTransition,
        optionTypes.component.backgroundColor,
        optionTypes.component.backgroundGradient,
        optionTypes.component.border,
        optionTypes.component.borderRadius,
        optionTypes.component.boxShadow,
        optionTypes.component.margin,
        optionTypes.component.padding,
        optionTypes.component.cursor,
        optionTypes.component.skewY,

        ...baseOrganismMappingClient.component,
    ],

    html: [
        optionTypes.html.dataDynamic,
        optionTypes.html.flexEvents,
        optionTypes.html.htmlCustomAttributes,
        optionTypes.html.isLink,
    ],

    linkBuilder: [optionTypes.linkBuilder.linkBuilder],

    text: [
        optionTypes.text.textAlignment,
        ...baseOrganismMappingClient.text,
    ],

    backgroundImage: [
        optionTypes.backgroundImage.attachment,
        optionTypes.backgroundImage.display,
        optionTypes.backgroundImage.image,
        optionTypes.backgroundImage.size,
        optionTypes.backgroundImage.position,
        optionTypes.backgroundImage.overlay,
        optionTypes.backgroundImage.overlayOpacity,
        optionTypes.backgroundImage.repeat,
    ],

    visibility: [
        optionTypes.visibility.disabled,
        optionTypes.visibility.opacity,
        optionTypes.visibility.visibility,

        ...baseOrganismMappingClient.visibility,
    ],

    accessibility: [
        optionTypes.accessibility.ariaLabel,
        optionTypes.accessibility.ariaLabelledBy,
        optionTypes.accessibility.accessibilityRole,
        optionTypes.accessibility.ariaHidden,

        ...baseOrganismMappingClient.accessibility,
    ],
};

export function mergeMappings(source, includes, excludes = {}) {
    const mergedObject = JSON.parse(JSON.stringify(source));

    Object.entries(includes).forEach((entry) => {
        const [optionType, optionsArray] = entry;
        let optionGroup = mergedObject[optionType];

        if (!optionGroup) {
            optionGroup = [];
            mergedObject[optionType] = optionGroup;
        }

        optionsArray.forEach((option) => {
            if (!optionGroup.includes(option)) {
                optionGroup.push(option);
            }
        });
    });

    Object.entries(excludes).forEach((entry) => {
        const [optionType, optionsArray] = entry;
        const optionGroup = mergedObject[optionType];
        if (!optionGroup) return;

        optionsArray.forEach((option) => {
            const excludeOptionIndex = optionGroup.findIndex(opt => opt.component === option.component);

            if (excludeOptionIndex > -1) {
                optionGroup.splice(excludeOptionIndex, 1);

                if (optionGroup.length === 0) delete mergedObject[optionType];
            }
        });
    });

    return mergedObject;
}
